<template>
  <div
    class="px-4 py-2 text-black border-2 border-black outline outline-1 outline-offset-[-1px] inline-flex justify-start items-center gap-4 absolute z-50 bottom-6 bg-[#EDE4CF] mobile-styles"
  >
    <div class="flex justify-start items-center gap-1">
      <div class="w-3 h-3">
        <InlineSvg :src="require('../../../../assets/images/ghetto_pin.svg')" />
      </div>
      <div class="justify-start text-xs md:text-sm font-normal font-['Merriweather'] leading-5">
        <static-string>Ghetto</static-string>
      </div>
    </div>
    <div class="flex justify-start items-center gap-1">
      <InlineSvg
        class="w-4 h-4"
        :src="require('../../../../assets/images/transit_ghetto_pin_new.svg')"
      />
      <div class="justify-start text-xs md:text-sm font-normal font-['Merriweather'] leading-5">
        <static-string>Transit Ghetto</static-string>
      </div>
    </div>
    <div class="flex justify-start items-center gap-1">
      <InlineSvg
        class="w-4 h-4"
        :src="require('../../../../assets/images/extermination_camp_new.svg')"
      />
      <div class="justify-start text-xs md:text-sm font-normal font-['Merriweather'] leading-5">
        <static-string>Extermination Camp</static-string>
      </div>
    </div>
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg';

export default {
  name: 'Labels',

  components: { InlineSvg },
};
</script>

<style lang="scss">
@media screen and (max-width: 768px) {
  .mobile-styles {
    justify-content: center !important;
    width: 100% !important;
    bottom: 0 !important;
  }
}
</style>
